import type { RecoilTaskInterface } from 'recoil-toolkit';

import { userService } from '../../api';
import { rolesState } from './atoms';

export const getRolesTask = ({ set }: RecoilTaskInterface) => async () => {
  const { roles } = await userService.getRoles();
  set(rolesState, roles);
};
